export enum MSV {
  FISCOD_ENABLED = 'FCD',
  LANGUAGE_SWITCH = 'LAN',
  RECOMMENDED = 'REC',
  GIFTCARD = 'GFC',
  FINANCING = 'FNC',
  EVENTS_CALENDAR = 'CLE',
  NETI = 'NET',
  DISABLED_FARES = 'DFR',
  FARE_HIDING_RULES = 'FHR',
  CCLUB_TOGGLE = 'CLB',
  NEW_DOCUMENT_SECTION = 'FLG',
  DISABLED_WEB_CHECK_IN = 'DWC',
  ENABLED_WEB_CHECK_IN = 'WCB',
  EMOTIONAL_QUOTATION = 'EMO',
  NEW_ROOM_SELECTOR = 'ROO',
  NEW_ROOM_SELECTOR_TWO = 'RO2',
  CCLUB_2022 = 'CLB22',
  SHIP_AND_SHOREX = 'SS2',
  ADDITIONAL_INFO = 'ADD',
  DISABLE_DEPOSIT = 'DEPO',
  CCLUB_DEFAULT_NO = 'FLGCLB',
  PAX_NUM_DEFAULT = 'PNUM',
  PAX_AGE_DEFAULT = 'PAGE',
  TRANSPORTATION_INFO = 'TRINFO',
  TRANSPORTATION_SELECTION = 'TRSEL',
  NATIONALITY_SELECTION = 'NATSEL',
  MYBOOKING_SEARCH = 'MYB',
  LOGIN_CAROUSEL = 'CAR',
  AGENCY_DETAIL_EXTENDED = 'AGX',
  NEW_SUMMARY_PRINT = 'NSP', //all
  NEW_SUMMARY_PRINT_EDIT = 'NSPEDT',
  GROUP_PAYMENT = 'GRPP',
  SEA_DESTINATION = 'SEA',
  BOOKING_PARTIAL_PAYMENT = 'BPP',
  NEW_MYEXPLOR_LAYOUT = 'NMXL',
  NEW_WORLD_PAY_REDIRECT = 'NWP',
  DEPARTED_GROUP = 'DGRP',
  HIDE_GROUP_RATE = 'HDGRP',
  CALIFORNIA_LAW = 'CLW',
  UPSELL_FARE = 'FUP',
  UPSELL_SSV = "SSVAPP",
  LOGIN_CONFIRM_ALERT = 'LCA',
  FULLPAYMENTSRECEIVED_OVERRIDE = 'FPO',
  NEW_USER_PAGE = 'USR',
  CHECK_USER_EMAIL ='UQEML',
  PARTIAL_PAYMENT_NET = 'PPN',
  CUSTOM_PROMO = "CPM",
  GEOLOC_SERVICE = "GEO2",
  PRICE_DELTA_CATEGORY_SELECTION = 'PDC',
  NEW_CATEGORY_SELECTION_UX = 'CUX',
  CHANGE_AGENCY_ADMIN = 'ADM',
  BUS_STATION_CITY_ORDER = 'BSCO',
  ROLLBED_ALERT = 'ROL',
  LOGIN_ERROR_WARNING = 'LEW',
  NEW_BOOKING_QUOTE_EDIT = 'NEWBKQ',
  NEW_FAMILY_PLAN = 'NEWFP',
  GRQ_FLIGHTS = 'GRQ',
  NEW_TRANSPORTATION_UI = 'NEWTR',
  PROGRESS_BAR = 'PRG',
  GATEWAY_SEARCH = 'GWAY',
  VIEW_COMMISSION_FLAG = 'VCF',
  SEGMENT_FILTER = "SGF",
  PAYMENT_PANEL_FLAG = "SPP",
  HSC_INCLUDED = "HSC",
  FREE_FAST_TRACK = "FFT",
  CCLUB_DISCOUNT = "CCD",
  NEW_SSV = "NEWSSV",
  ADD_USER_CONTEST = "ADU",
  PORT_PRIORITY = "PTP",
  REMOVE_GTW_CODE = "RGC",
  TRAIN_EQUIPMENT = "TRN",
  PRINT_SIGNATURE_PAGE = "PSP",
  PROMO_BLACK_FRIDAY = "PBF",
  NEW_DESTINATIONS = "NWDEST",
  NEW_FUNNEL_26 = "FUN26",
  ALTERNATIVE_WEEKS = "ALTW",
  UPSELL_MODAL = "UPSM",
  MULTIPLE_GROUP_FILTERS = "GRPGRP",
  COMMISSION_VULKI = "COM",
  TRAVEL_AGENCY_PROFILE = "TAP",
  SUBAGENTS = "SUB",
  ITINERARY_CONCEPT = "ITCON",
  SUPERCOMM_FLAG = "SUPFLAG",
  HIDE_PAYMENT_BUTTON = "HPB",
  DEUTSCHE_BAHN_VOUCHER = "DBV",
  RAIL_PROJECT = "RAIL",
  WITHHOLDING_TAX = 'WHT',
  PRICE_STATS = 'PST',
  SHOW_REA_NUMBER = 'SRN',
  SHOW_HSC_INCLUDED_ICON = 'ICHSC',
  MVP = 'MVP',
  CART_UX = 'CRT',
  CART_FARES_UX = 'CTFR',
  FARE_SELECTION_NEW = 'FSNEW'
}
